import { render, staticRenderFns } from "./JourneyCRUD.vue?vue&type=template&id=a3a9fa6e&lang=pug&"
import script from "./JourneyCRUD.vue?vue&type=script&lang=js&"
export * from "./JourneyCRUD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})
